import { createContext, useContext } from "react";

import type { CIOBrowseProduct } from "~/hec/.server/cio-products.server";

interface CarouselProductsContextValue {
  categoryId?: string;
  products: CIOBrowseProduct[];
  isLoading: boolean;
}

const CarouselProductsContext = createContext<CarouselProductsContextValue>({
  products: [],
  isLoading: false,
});

export const CarouselProductsProvider = CarouselProductsContext.Provider;

// eslint-disable-next-line react-refresh/only-export-components
export function useCarouselProducts(): CarouselProductsContextValue {
  return useContext(CarouselProductsContext);
}
